module.exports = __webpack_public_path__ + "img/team-background.025f0c8d.png";